import { FC } from 'react';
import TextField from '../Fields/TextField';
import {
  LinkConfigurationsOutputData,
  MerchantConfigurationsOutputData,
  OpenInputType,
} from '../../../../middlewares/Open/openTypes';
import MerchantCommissionsSelect from './MerchantConfigurations/MerchantCommissionsSelect';

interface MerchantConfigurationsInputFieldProps {
  merchantConfiguration: MerchantConfigurationsOutputData;
  displayInputs: OpenInputType;
  dismissedFields: { [key: string]: boolean };
  errors: { [key: string]: string | null };
  onDismissField: (name: string, dismiss: boolean) => void;
}

const MerchantConfigurationsInputField: FC<
  MerchantConfigurationsInputFieldProps
> = (props) => {
  const {
    merchantConfiguration,
    displayInputs,
    dismissedFields,
    errors,
    onDismissField,
  } = props;

  const translateMerchantConfigurationToLinkConfiguration = (
    merchantConfiguration: MerchantConfigurationsOutputData
  ): LinkConfigurationsOutputData => {
    return {
      id: merchantConfiguration.id,
      customFieldType: merchantConfiguration.configurationType,
      position: merchantConfiguration.position,
      hidden: merchantConfiguration.hidden,
      label: merchantConfiguration.label,
      dismissable: merchantConfiguration.dismissable,
      value: merchantConfiguration.value,
      name: merchantConfiguration.name,
      placeholder: merchantConfiguration.placeholder || '',
      validations: merchantConfiguration.validations
        ? merchantConfiguration.validations.split(',')
        : [],
      data: null,
    };
  };

  const fieldTypeDict = {
    'MerchantConfigurations::Fields::PaymentMethodCommissions': (
      <MerchantCommissionsSelect
        key={merchantConfiguration.id}
        inputs={displayInputs}
        merchantConfiguration={merchantConfiguration}
        dismissed={dismissedFields[merchantConfiguration.name]}
      />
    ),
  };

  if (merchantConfiguration.configurationType in fieldTypeDict) {
    return fieldTypeDict[
      merchantConfiguration.configurationType as keyof typeof fieldTypeDict
    ];
  }
  return (
    <TextField
      key={merchantConfiguration.id}
      inputs={displayInputs}
      linkConfiguration={translateMerchantConfigurationToLinkConfiguration(
        merchantConfiguration
      )}
      dismissed={dismissedFields[merchantConfiguration.name]}
      onDismissField={onDismissField}
      error={errors[merchantConfiguration.name]}
    />
  );
};

export default MerchantConfigurationsInputField;
